import React from "react";
import { Label } from "@/components/ui/label";

export function SectionHeader({ step, label }: { step: number; label: string }) {
  return (
    <div className="flex items-center gap-2 mb-3">
      <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-bold shrink-0">
        {step}
      </span>
      <span className="text-sm font-semibold text-foreground uppercase tracking-wide">
        {label}
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}

export function FieldRow({ children }: { children: React.ReactNode }) {
  return <div className="mb-4">{children}</div>;
}

export function FieldLabel({
  htmlFor,
  required,
  children,
}: {
  htmlFor: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Label htmlFor={htmlFor} className="font-semibold mb-1.5 block text-sm">
      {children}
      {required && <span className="text-destructive ml-0.5">*</span>}
    </Label>
  );
}

export function ErrorMsg({ msg }: { msg?: string }) {
  if (!msg) return null;
  return <p className="text-xs text-destructive mt-1">{msg}</p>;
}
